module.exports = __webpack_public_path__ + "static/media/macball.15262ecf.svg";